import { roundGpsCoordinates, type GpsCoordinates } from '@qkindex/contracts';

export type { GpsCoordinates };

/** Collection GPS is stored and set to two decimal places (~1.1km precision). */
export const roundGpsTo2Decimals = roundGpsCoordinates;

export interface Location {
  /** Collection scope; id and locationId remain storage IDs. */
  collectionId?: string;
  collectionName?: string;
  id: string;
  name: string;
  normalizedName: string;
  description: string;
  createdAt: string;
  lastEditedAt?: string;
  lastEditedBy?: string;
}

export const normalizeLocationName = (name: string): string =>
  name.trim().replace(/\s+/g, ' ').toLowerCase();

export const isValidGps = (gps: unknown): gps is GpsCoordinates => {
  if (!gps || typeof gps !== 'object') return false;
  const candidate = gps as Record<string, unknown>;
  return (
    typeof candidate.latitude === 'number' &&
    Number.isFinite(candidate.latitude) &&
    candidate.latitude >= -90 &&
    candidate.latitude <= 90 &&
    typeof candidate.longitude === 'number' &&
    Number.isFinite(candidate.longitude) &&
    candidate.longitude >= -180 &&
    candidate.longitude <= 180
  );
};
